export interface ClerkSessionClient {
  isLoaded: boolean;
  isSignedIn: boolean;
  userId: string | null;
  getToken: () => Promise<string | null>;
  signOut: () => Promise<void>;
}

let clerkClient: ClerkSessionClient | null = null;
const clerkClientListeners = new Set<(client: ClerkSessionClient | null) => void>();

export function setClerkSessionClient(client: ClerkSessionClient | null): void {
  clerkClient = client;
  clerkClientListeners.forEach((listener) => listener(client));
}

export function getClerkSessionClient(): ClerkSessionClient | null {
  return clerkClient;
}

export async function signOutClerkSession(): Promise<void> {
  let client = clerkClient;
  if (client && !client.isLoaded) {
    client = await new Promise<ClerkSessionClient | null>((resolve) => {
      let settled = false;
      const finish = (value: ClerkSessionClient | null) => {
        if (settled) return;
        settled = true;
        clearTimeout(timeout);
        clerkClientListeners.delete(onClient);
        resolve(value);
      };
      const onClient = (next: ClerkSessionClient | null) => {
        if (next?.isLoaded) finish(next);
      };
      const timeout = setTimeout(() => finish(clerkClient), 5_000);
      clerkClientListeners.add(onClient);
      onClient(clerkClient);
    });
  }
  if (client?.isLoaded && client.isSignedIn) {
    await client.signOut();
  }
}

export function getExchangedClerkIdentity(): string | null {
  return sessionStorage.getItem("alta_clerk_identity");
}

export function setExchangedClerkIdentity(identity: string | null): void {
  if (identity) sessionStorage.setItem("alta_clerk_identity", identity);
  else sessionStorage.removeItem("alta_clerk_identity");
}